import {
	ImageReference,
	OptimizelyLongString,
	OptimizelyXhtmlString,
} from '../index';
import { OptimizelyBlockExpandedValue } from '../expanded';

export interface BasicBenefitsListBlock extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'BenefitsListBlock'];
}

export interface ExpandedBenefitBlock extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'BenefitBlock'];
	name: string;
	text: OptimizelyXhtmlString;
	image: ImageReference;
}

export interface ExpandedBenefitsListBlock extends BasicBenefitsListBlock {
	title: OptimizelyLongString;
	textEditor: OptimizelyXhtmlString;
	fontColor: OptimizelyLongString;
	backgroundColor: OptimizelyLongString;
	benefits: {
		expandedValue: ExpandedBenefitBlock[];
	};
}

export const isBenefitsListBlock = (
	block: OptimizelyBlockExpandedValue,
): block is BasicBenefitsListBlock => {
	return block.contentType[1] === 'BenefitsListBlock';
};

export interface Benefit {
	imageUrl: string;
	text: string;
	id: string;
	name: string;
}
export interface BenefitsListBlockData {
	title: string;
	titleContent: string;
	backgroundColor: string;
	fontColor?: string;
	benefits: Benefit[];
}
